import defaultState from './defaultState'

const getState = state => state.ratingWidget || defaultState

export const getViewedJobs = (state) => {
  return getState(state).viewedJobs
}

export const getEnabled = (state) => {
  return getState(state).enabled
}

export const getShowWidget = (state) => {
  return getState(state).show
}
